import Vue from 'vue'
import {
  Button,
  Drawer,
  Empty,
  Form,
  FormItem,
  Icon,
  Input,
  Menu,
  Select,
  Option,
  Popover,
  Submenu,
  Tabs,
  TabPane,
  MenuItem,
  MenuItemGroup,
  Message
} from 'element-ui'

Vue.use(Button)
Vue.use(Drawer)
Vue.use(Empty)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Menu)
Vue.use(Select)
Vue.use(Option)
Vue.use(Popover)
Vue.use(Submenu)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)

Vue.prototype.$message = Message
